import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Form, notification } from "antd";
import moment from "moment";
import { buildLookupRequest, civilRequest } from "../../../state/connect-api";
import { updateAllQueryList } from "../../../state/queryStore";
import {
  useTrCrDailyListMutation,
  useTrCrArraignmentListMutation,
  useTrCrAttorneyListMutation,
  useTrCrAgencyListMutation,
  useCivilDailyQueryMutation,
  useCivilAttorneyQueryMutation
} from "../../../state/query-api";
import { QueryList } from "../../../common/constants/helpers";

const useQuery = () => {
  const initialValues = { type: 1 };
  const allTypes = [
    { index: 1, value: "All" },
    { index: 2, value: "Single" },
    { index: 3, value: "Range" }
  ];
  const [form] = Form.useForm();
  const [type, setType] = useState<number>(initialValues.type);
  const [getTrCrDailyList] = useTrCrDailyListMutation();
  const [getTrCrArraignmentList] = useTrCrArraignmentListMutation();
  const [getTrCrAttorneyList] = useTrCrAttorneyListMutation();
  const [getTrCrAgencyList] = useTrCrAgencyListMutation();
  const [getCivilDailyList] = useCivilDailyQueryMutation();
  const [getCivilAttorneyList] = useCivilAttorneyQueryMutation();
  const dispatch = useDispatch();
  const history = useNavigate();

  const handleTypeChange = (value: number) => {
    if (value === allTypes[0].index) {
      form.resetFields(["startJudge", "startAttorney", "startAgency", "endJudge", "endAttorney", "endAgency"]);
    }
    if (type !== allTypes[2].index) {
      form.resetFields(["endJudge", "endAttorney", "endAgency"]);
    }
    setType(value);
  };

  const handleSubmit = async (fromPage, param1 = null, param2 = null) => {
    let startDate, endDate;
    await form.validateFields();
    if (form.getFieldValue("date") && form.getFieldValue("date")[0] && form.getFieldValue("date")[1]) {
      startDate = form.getFieldValue("date")[0];
      endDate = form.getFieldValue("date")[1];
      if (moment(endDate).diff(moment(startDate), "days") > 14) {
        notification.error({ message: "Date range should not exceed 14 days" });
        return;
      }
    } else {
      startDate = moment().toISOString();
      endDate = moment().toISOString();
    }
    let lookupRequest = {};
    let queryDailyResult = {};
    switch (fromPage) {
      case QueryList.TRCRDaily:
        lookupRequest = buildLookupRequest(startDate, endDate, param1, param2);
        queryDailyResult = await getTrCrDailyList(lookupRequest).unwrap();
        dispatch(updateAllQueryList({ allQueryResult: queryDailyResult }));
        history("/tr-cr-query/daily-query/list", { replace: true, state: fromPage });
        break;
      case QueryList.TRCRArraignment:
        lookupRequest = buildLookupRequest(startDate, endDate, param1, param2);
        queryDailyResult = await getTrCrArraignmentList(lookupRequest).unwrap();
        dispatch(updateAllQueryList({ allQueryResult: queryDailyResult }));
        history("/tr-cr-query/arraignment-query/list", { replace: true, state: fromPage });
        break;
      case QueryList.TRCRAttorney:
        lookupRequest = buildLookupRequest(startDate, endDate, param1, param2);
        queryDailyResult = await getTrCrAttorneyList(lookupRequest).unwrap();
        dispatch(updateAllQueryList({ allQueryResult: queryDailyResult }));
        history("/tr-cr-query/attorney-query/list", { replace: true, state: fromPage });
        break;
      case QueryList.TRCRAgency:
        lookupRequest = buildLookupRequest(startDate, endDate, param1, param2);
        queryDailyResult = await getTrCrAgencyList(lookupRequest).unwrap();
        dispatch(updateAllQueryList({ allQueryResult: queryDailyResult }));
        history("/tr-cr-query/agency-query/list", { replace: true, state: fromPage });
        break;
      case QueryList.CivilDaily:
        lookupRequest = civilRequest(startDate, endDate);
        queryDailyResult = await getCivilDailyList(lookupRequest).unwrap();
        dispatch(updateAllQueryList({ allQueryResult: queryDailyResult }));
        history("/civil-query/daily-query/list", { replace: true, state: fromPage });
        break;
      case QueryList.CivilAttorney:
        if (param1 === null && param2 === null) {
          param1 = 293354;
          param2 = 292422;
        }
        lookupRequest = buildLookupRequest(startDate, endDate, param1, param2);
        queryDailyResult = await getCivilAttorneyList(lookupRequest).unwrap();
        dispatch(updateAllQueryList({ allQueryResult: queryDailyResult }));
        history("/civil-query/attorney-query/list", { replace: true, state: fromPage });
        break;
    }
  };

  return { initialValues, handleTypeChange, type, form, allTypes, handleSubmit };
};

export default useQuery;
